import styled from 'styled-components/macro';
import { fontSize } from '../../styles/mixins';
import media from '../../styles/media';

export const Placeholder = styled.label`
  pointer-events: none;
  color: ${({ theme, invalid, active, disabled }) =>
    (invalid && theme.invalidColor) ||
    (active && theme.placeholderActiveColor) ||
    (disabled && theme.placeholderDisabledColor) ||
    theme.placeholderColor};
  font-weight: ${({ active }) => (active ? 'normal' : '500')};
  letter-spacing: 0.4px;
  ${({ active }) => fontSize(active ? 10 : 14)};
  position: absolute;
  left: 10px;
  top: ${({ active }) => (active ? '6px' : '16px')};
  transition: 0.2s ease all;

  ${media.desktop`
    left: 20px;
    top: ${({ active }) => (active ? '10px' : '18px')};
  `};
`;
